import React from 'react'
import { Box, Image, minWidths } from '@mindfulchefuk/design-system'

export const GiftCardImage = () => (
  <Box>
    <Image
      resolve
      src="/gift-cards/gift-card-mobile.png"
      alt="Gift Card Image"
      width={656}
      height={381}
      sources={[
        {
          src: '/gift-cards/gift-card-desktop.png',
          media: minWidths.sm,
          width: 718,
          height: 492,
        },
      ]}
    />
  </Box>
)
